import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import { InfoFilledIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { AI_CHAT_ASSISTANT_SLOW_WARNING_MESSAGE } from 'constants/aiChat';
import { IconSize } from 'constants/coreDesignSystem';

import { selectAiChatIsAssistantSlow } from 'store/aiChat/selectors';

import { AiChatTestIds } from '../../AiChat.testIds';

import { containerStyles, iconStyles } from './AssistantSlowWarning.styles';

const AssistantSlowWarning = () => {
  const isSlow = useSelector(selectAiChatIsAssistantSlow);

  if (!isSlow) {
    return null;
  }

  return (
    <Box data-testid={AiChatTestIds.ASSISTANT_SLOW_WARNING} sx={containerStyles}>
      <Box sx={iconStyles}>
        <InfoFilledIcon size={IconSize[20]} />
      </Box>
      <Typography color="text.primary" variant="regular14">
        {AI_CHAT_ASSISTANT_SLOW_WARNING_MESSAGE}
      </Typography>
    </Box>
  );
};

export default memo(AssistantSlowWarning);
